// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Load end screen for 
 * @author James Reid
 */

// @ts-check

// @@imports-package
import { App } from "../../app/index.js"
import { SteppedContainer } from "../../components/index.js"

import { Layout } from "../Layout.js"

// @@imports-utils
import { cloneTemplate } from "../../utils/index.js"

// @@imports-types
import { STEP_TYPES } from "../../types/StepType.js"

// @@body
const endScreen = new Layout(async () => {
    const { container } = App.instance

    // Add page which notifies user that quote has already been added to basket,
    // so cannot be modified (?) 

    // Change this to have the lifecycle name match the template id so that we
    // can remove ternary 
    const templateId = App.state.pageOptions.lifecycle === "failed"
            ? "end-screen-fail"
        : App.state.pageOptions.lifecycle === "basket"
            ? "end-screen-basket"
        : App.state.pageOptions.lifecycle === "no-modify"
            ? "end-screen-no-modify"
        : "end-screen-default"
    const modal = SteppedContainer.createContainer("modal")
    const endScreen = cloneTemplate(templateId)

    endScreen.querySelector("button")?.addEventListener("click", () => {
        // Fetch current search params and delete any entries which may hav
        // been set pertaining to a specific quote.
        const searchParams = new URLSearchParams(window.location.search)
        searchParams.delete("quoteId")
        searchParams.delete("lineItems")
        searchParams.delete("token")

        // Reload iframe with URL stripped of quote-specific query params.
        window
            .location
            .replace(`${window.location.origin}/?${searchParams.toString()}`)
    })

    modal.append(endScreen)
    container.loadModal(modal)
}, {
    id: "end-screen",
    title: "End Quote",
    name: "End",
    type: STEP_TYPES.end
})

// @@exports
export { endScreen }
